module.exports = __webpack_public_path__ + "img/guard-dog-600.9fb5cab0.webp";